(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oxiclear-legacy-collection-page"] && !Shopify.designMode) return;
  try {
    
  /* Colour picking on the Shop tiles (D-191 follow-up, 1 Sep 2026). One
     delegated handler for every [data-oc-variant-chip]: it retargets the
     tile's add form to the picked variant and follows with the image, the
     colour name and the price. The form itself stays a plain POST with a
     preselected variant, so picking is enhancement, never a requirement.
     Compiled sitewide like the quick-add handler; scopes make it inert
     anywhere without the markup. */
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-oc-variant-chip]');
    if (!chip) return;
    const scope = chip.closest('[data-oc-variant-scope]');
    if (!scope) return;

    scope.querySelectorAll('[data-oc-variant-chip]').forEach((other) => {
      other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
    });

    const input = scope.querySelector('[data-oc-variant-input]');
    if (input) input.value = chip.dataset.variantId;

    const name = scope.querySelector('[data-oc-variant-name]');
    if (name && chip.dataset.variantName) name.textContent = chip.dataset.variantName;

    const price = scope.querySelector('[data-oc-variant-price]');
    if (price && chip.dataset.variantPrice) price.textContent = chip.dataset.variantPrice;

    const image = scope.querySelector('[data-oc-variant-image]');
    if (image && chip.dataset.variantImage) {
      image.src = chip.dataset.variantImage;
      image.removeAttribute('srcset');
      if (chip.dataset.variantName) image.alt = chip.dataset.variantName;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oxiclear-legacy-faq__list').forEach((faqList) => {
    faqList.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        faqList.querySelectorAll('details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async (root) => {
      if (!root || root.dataset.legacyRecommendationsReady === 'true') return;
      root.dataset.legacyRecommendationsReady = 'true';
      if (root.dataset.legacyRecommendationsPerformed === 'true' || !root.dataset.legacyRecommendationsUrl) return;
      try {
        const response = await fetch(root.dataset.legacyRecommendationsUrl);
        if (!response.ok) return;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = documentFragment.querySelector('[data-legacy-recommendations-root]');
        if (replacement) {
          root.innerHTML = replacement.innerHTML;
          root.hidden = !replacement.querySelector('.oc-pdp-rec');
        }
      } catch (error) {
        void error;
      }
    };

    document.querySelectorAll('[data-legacy-recommendations-root]').forEach(load);
    document.addEventListener('shopify:section:load', (event) => load(event.target.querySelector('[data-legacy-recommendations-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-product-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.legacyProductReady === 'true') return;
      root.dataset.legacyProductReady = 'true';

      const variantsNode = root.querySelector('[data-legacy-variants]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const optionGroups = Array.from(root.querySelectorAll('[data-legacy-option]'));
      const variantSelect = root.querySelector('[data-legacy-variant-select]');
      const price = root.querySelector('[data-legacy-price]');
      const compare = root.querySelector('[data-legacy-compare]');
      const discount = root.querySelector('[data-legacy-discount]');
      const saleBadge = root.querySelector('[data-legacy-sale-badge]');
      const addButton = root.querySelector('[data-legacy-add]');
      const addLabel = root.querySelector('[data-legacy-add-label]');
      const addPrice = root.querySelector('[data-legacy-add-price]');
      const priceNote = root.querySelector('[data-legacy-price-note]');
      const sku = root.querySelector('[data-legacy-sku]');
      const mediaPanels = Array.from(root.querySelectorAll('[data-legacy-media]:not([data-legacy-media-hidden="true"])'));
      const mediaControls = Array.from(root.querySelectorAll('[data-legacy-media-target]:not([data-legacy-media-hidden="true"])'));
      const galleryStage = root.querySelector('[data-legacy-stage]');
      const thumbnailChangesVariant = root.dataset.thumbnailChangesVariant === 'true';

      const selectMedia = (mediaId) => {
        const id = String(mediaId);
        mediaPanels.forEach((panel) => {
          const active = panel.dataset.legacyMedia === id;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (!active) {
            panel.querySelectorAll('video').forEach((video) => video.pause());
          }
        });
        mediaControls.forEach((control) => {
          const active = control.dataset.legacyMediaTarget === id;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const selectedOptions = () => optionGroups.map((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });

      const findVariant = () => {
        const values = selectedOptions();
        return variants.find((variant) => variant.options.every((option, index) => option === values[index]));
      };

      const updateVariant = (variant, updateUrl = true) => {
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }

        if (variantSelect) {
          variantSelect.value = String(variant.id);
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = variant.price_formatted;

        const onSale = variant.compare_at_price > variant.price;
        if (compare) {
          compare.textContent = variant.compare_at_price_formatted;
          compare.classList.toggle('is-hidden', !onSale);
        }
        if (discount) {
          const saving = onSale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
          discount.textContent = onSale ? `-${saving}%` : '';
          discount.classList.toggle('is-hidden', !onSale);
        }
        if (saleBadge) saleBadge.classList.toggle('is-hidden', !onSale);
        if (addButton) addButton.disabled = !variant.available;
        /* Button and note copy are declared in Liquid, never here. */
        if (addLabel && addButton) {
          addLabel.textContent = variant.available
            ? (addButton.dataset.labelAvailable || addLabel.textContent)
            : (addButton.dataset.labelSoldOut || addLabel.textContent);
        }
        if (addPrice) {
          addPrice.textContent = `· ${variant.price_formatted}`;
          addPrice.hidden = !variant.available;
        }
        if (priceNote) {
          priceNote.textContent = `${variant.options.join(' · ')} · ${priceNote.dataset.legacyNoteTail}`;
        }
        if (sku) sku.textContent = variant.sku || '';

        if (variant.featured_media_id && thumbnailChangesVariant) selectMedia(variant.featured_media_id);

        if (updateUrl && window.history.replaceState && variants.length > 1) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        }
      };

      optionGroups.forEach((group) => {
        group.addEventListener('change', () => updateVariant(findVariant()));
      });

      mediaControls.forEach((control) => {
        control.addEventListener('click', () => {
          selectMedia(control.dataset.legacyMediaTarget);
          const targetVariantId = control.dataset.legacyVariantTarget;
          if (!thumbnailChangesVariant || !targetVariantId) return;
          const targetVariant = variants.find((variant) => String(variant.id) === targetVariantId);
          if (!targetVariant) return;
          targetVariant.options.forEach((value, index) => {
            const input = optionGroups[index] && Array.from(optionGroups[index].querySelectorAll('input')).find((candidate) => candidate.value === value);
            if (input) input.checked = true;
          });
          updateVariant(targetVariant);
        });
      });

      if (galleryStage) {
        galleryStage.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const activeIndex = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
          if (activeIndex < 0) return;
          event.preventDefault();
          const offset = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (activeIndex + offset + mediaPanels.length) % mediaPanels.length;
          selectMedia(mediaPanels[nextIndex].dataset.legacyMedia);
        });

        let touchStartX = null;
        galleryStage.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        galleryStage.addEventListener('touchend', (event) => {
          if (touchStartX === null || window.innerWidth > 480) return;
          const difference = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(difference) < 45) return;
          const activeIndex = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
          const offset = difference < 0 ? 1 : -1;
          const nextIndex = (activeIndex + offset + mediaPanels.length) % mediaPanels.length;
          selectMedia(mediaPanels[nextIndex].dataset.legacyMedia);
        }, { passive: true });
      }

      const minus = root.querySelector('[data-legacy-quantity-minus]');
      const plus = root.querySelector('[data-legacy-quantity-plus]');
      const quantity = root.querySelector('input[name="quantity"]');
      if (minus && quantity) minus.addEventListener('click', () => { quantity.value = Math.max(1, Number.parseInt(quantity.value || '1', 10) - 1); });
      if (plus && quantity) plus.addEventListener('click', () => { quantity.value = Math.max(1, Number.parseInt(quantity.value || '1', 10) + 1); });

      /* Living slots: the AQI tease and the line under the price. Both ship with
         `hidden` set and stay that way unless the Air Check service answers with a
         real index - no reading, no number, no half-sentence. Copy templates come
         from the markup; this only fills the placeholders. */
      const aqiSlot = root.querySelector('[data-legacy-aqi]');
      const livingSlot = root.querySelector('[data-legacy-living]');
      const aqiEndpoint = root.dataset.aqiEndpoint;
      if (aqiEndpoint && (aqiSlot || livingSlot)) {
        const fill = (template, values) => String(template || '').replace(
          /\{(place|index|status)\}/g,
          (match, key) => values[key]
        );
        fetch(aqiEndpoint, { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((response) => (response.ok ? response.json() : null))
          .then((payload) => {
            const current = (payload && payload.current) || null;
            const place = (payload && payload.location && payload.location.name) || '';
            const index = current ? Number(current.index) : Number.NaN;
            if (!Number.isFinite(index)) return;
            const display = current.display === undefined || current.display === null || current.display === ''
              ? String(Math.round(index))
              : String(current.display);
            const values = { place, index: display, status: current.status || '' };
            if (aqiSlot && values.status) {
              const text = aqiSlot.querySelector('[data-legacy-aqi-text]');
              if (text) text.textContent = fill(aqiSlot.dataset.legacyAqiTemplate, values);
              /* Full-colour band glass: the cell takes the meter's own colour, the
                 same way the Air Check card does. Only a 6-digit hex the service
                 actually returned is used — anything else leaves the neutral frost
                 in place rather than guessing a band. */
              const hex = /^#([0-9a-f]{6})$/i.exec(String(current.color || ''));
              if (hex) {
                aqiSlot.style.setProperty('--oc-aqi-tint', '#' + hex[1]);
                /* The ink has to flip: Moderate is pure #FFFF00, Very Poor is a
                   near-black maroon. The Air Check card switches on a luminance
                   threshold, but a single cutoff picks wrong on the Poor band —
                   measured on the rendered pill, white on #FF0000 gives 3.7:1 while
                   black gives 4.8:1, so the threshold would have chosen the less
                   legible ink. Compute the real WCAG contrast of both inks against
                   the composited fill and take the better one; it cannot pick wrong
                   on a band nobody has tested yet. */
                const n = parseInt(hex[1], 16);
                const chan = (c) => { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
                const lum = (r, g, b) => 0.2126 * chan(r) + 0.7152 * chan(g) + 0.0722 * chan(b);
                /* 82% tint over the white buy stage behind it — matches --oc-aqi-fill */
                const mix = (c) => 0.82 * c + 0.18 * 250;
                const fill = lum(mix(n >> 16 & 255), mix(n >> 8 & 255), mix(n & 255));
                const ratio = (a, b) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
                const onLight = ratio(fill, lum(20, 23, 28));
                const onWhite = ratio(fill, 1);
                aqiSlot.dataset.aqiInk = onWhite > onLight ? 'light' : 'dark';
              }
              aqiSlot.hidden = false;
            }
            if (livingSlot && place) {
              livingSlot.textContent = fill(livingSlot.dataset.legacyLivingTemplate, values);
              livingSlot.hidden = false;
            }
          })
          .catch(() => {});
      }

      const readmore = root.querySelector('[data-legacy-readmore]');
      if (readmore) {
        const content = readmore.querySelector('[data-legacy-readmore-content]');
        const toggle = readmore.querySelector('[data-legacy-readmore-toggle]');
        const label = readmore.querySelector('[data-legacy-readmore-label]');
        const icon = readmore.querySelector('[data-legacy-readmore-icon]');
        if (content && toggle) {
          if (content.scrollHeight <= 116) toggle.hidden = true;
          toggle.addEventListener('click', () => {
            const open = readmore.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (label) label.textContent = open ? 'Read less' : 'Read more';
            if (icon) icon.textContent = open ? '⌃' : '⌄';
            if (!open) readmore.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      }

      root.querySelectorAll('.oc-legacy-pdp__description ul.tabs').forEach((tabs) => {
        const links = Array.from(tabs.querySelectorAll('a[href^="#"]'));
        links.forEach((link, index) => {
          const target = root.querySelector(link.getAttribute('href')) || document.querySelector(link.getAttribute('href'));
          if (!target) return;
          link.classList.toggle('active', index === 0);
          target.hidden = index !== 0;
          link.addEventListener('click', (event) => {
            event.preventDefault();
            links.forEach((candidate) => {
              candidate.classList.remove('active');
              const panel = root.querySelector(candidate.getAttribute('href')) || document.querySelector(candidate.getAttribute('href'));
              if (panel) panel.hidden = true;
            });
            link.classList.add('active');
            target.hidden = false;
          });
        });
      });

      const zoomDialog = root.querySelector('[data-legacy-zoom-dialog]');
      const zoomImage = root.querySelector('[data-legacy-zoom-image]');
      root.querySelectorAll('[data-legacy-zoom-src]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          if (!zoomDialog || !zoomImage) return;
          // the markup ships loading="lazy" so the closed dialog never downloads
          // the 2400px render; opening is the explicit ask, so load eagerly now
          zoomImage.loading = 'eager';
          zoomImage.src = trigger.dataset.legacyZoomSrc;
          const image = trigger.querySelector('img');
          zoomImage.alt = image ? image.alt : '';
          if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
        });
      });
      if (zoomDialog) {
        zoomDialog.addEventListener('click', (event) => {
          if (event.target === zoomDialog) zoomDialog.close();
        });
      }

      try {
        const key = 'theme:recently-viewed-products';
        const productId = Number.parseInt(root.dataset.productId, 10);
        const stored = JSON.parse(localStorage.getItem(key) || '[]').filter((id) => id !== productId);
        stored.unshift(productId);
        localStorage.setItem(key, JSON.stringify(stored.slice(0, 12)));
      } catch (error) {
        void error;
      }
    };

    document.querySelectorAll('[data-legacy-product]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-legacy-product]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindObserver = (section) => {
      const wrapper = section.querySelector('[data-recently-viewed-wrapper]');
      const products = section.querySelector('recently-viewed-products');
      if (!wrapper || !products || products.dataset.legacyObserved === 'true') return;
      products.dataset.legacyObserved = 'true';
      const reveal = () => {
        if (products.querySelector('.oc-legacy-pdp-carousel__item')) wrapper.style.display = 'block';
      };
      reveal();
      new MutationObserver(reveal).observe(products, { childList: true, subtree: true });
    };

    document.querySelectorAll('.section-oxiclear-legacy-recently-viewed').forEach(bindObserver);
    document.addEventListener('shopify:section:load', (event) => bindObserver(event.target));

    /* Moved here with the carousel CSS on 21 Aug 2026: recommendations no longer
       has arrows, so this delegated handler followed its last consumer. */
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-legacy-carousel-previous], [data-legacy-carousel-next]');
      if (!button) return;
      const viewport = button.closest('.oc-legacy-pdp-carousel__viewport');
      const track = viewport && viewport.querySelector('[data-legacy-carousel-track]');
      if (!track) return;
      const direction = button.hasAttribute('data-legacy-carousel-next') ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-shop-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oxiclear-legacy-shop-tabs')) {
    customElements.define('oxiclear-legacy-shop-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            this.activate(nextIndex);
            this.tabs[nextIndex].focus();
          });
        });
      }

      activate(activeIndex) {
        this.tabs.forEach((tab, index) => {
          const selected = index === activeIndex;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[index].hidden = !selected;
        });

        this.tabs[activeIndex].scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    });
  }

  document.querySelectorAll('.oc-legacy-shop__mobile').forEach((accordionGroup) => {
    accordionGroup.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        accordionGroup.querySelectorAll('details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.open = false;
        });
      });
    });
  });

  /* V2.5 quick Add to Cart (19 Aug 2026): single-variant cards add via /cart/add.js
     without leaving the page; on any failure the form falls back to a normal POST. */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-oc-quick-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('oc-quick-add-failed');
        return fetch('/cart.js');
      })
      .then((response) => response.json())
      .then((cart) => {
        document
          .querySelectorAll('.cart-count, [data-cart-count], [data-header-cart-count], .site-header__cart-count, .cart-item-count-header, .cart-count-number')
          .forEach((el) => {
            el.textContent = cart.item_count;
          });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        button.textContent = 'Added ✓';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1600);
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = originalText;
        form.submit();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oxiclear-legacy-video-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.oc-legacy-video-row__item').forEach((item) => {
    const trigger = item.querySelector('[data-legacy-video-open]');
    const dialog = item.querySelector('[data-legacy-video-dialog]');
    const close = item.querySelector('[data-legacy-video-close]');
    const video = dialog?.querySelector('video');
    if (!trigger || !dialog || !close || !video) return;

    trigger.addEventListener('click', () => {
      dialog.showModal();
      video.play().catch(() => {});
    });

    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      video.currentTime = 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
